import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import ENV from '../base/env';
import { EDomain } from '../base/types';
import NumberSlider from '../components/NumberSlider/NumberSlider';
import './DomainSliderContainer.scss';

export interface IDomainPercent {
  domain: EDomain;
  percent: number;
}

export interface IDomainSliderContainerProps {
  data: IDomainPercent;
  sliderVisible: boolean;
  onChange: (domain: EDomain, stat: number) => void;
}
export const DomainSliderContainer: React.FC<IDomainSliderContainerProps> = ({
  data: { domain, percent },
  sliderVisible,
  onChange,
}) => {
  const { t } = useTranslation();

  const domainIcon = `${ENV.AssetsBaseUrl}/feature/icons/${EDomain[domain]}.png`;
  const domainTitle = t(`common:Domain.Title.${domain}`);

  return (
    <div className="domain-slider-container row">
      <div className="col-4" />
      <div className="title-container col-4">
        <img src={domainIcon} alt={domainTitle} />
        <span>{domainTitle}</span>
      </div>
      {sliderVisible && (
        <NumberSlider
          className={`col-4 ${EDomain[domain].toLowerCase()}`}
          min={0}
          max={1000000}
          value={percent}
          onChangeEnd={(value: number) => onChange(domain, value)}
        />
      )}
    </div>
  );
};

export default DomainSliderContainer;
